import { render, staticRenderFns } from "./LearcnAboutProfiles.vue?vue&type=template&id=7b848f4a&scoped=true"
import script from "./LearcnAboutProfiles.vue?vue&type=script&lang=js"
export * from "./LearcnAboutProfiles.vue?vue&type=script&lang=js"
import style0 from "./LearcnAboutProfiles.vue?vue&type=style&index=0&id=7b848f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b848f4a",
  null
  
)

export default component.exports